import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import debounceAction from '../../../../shared/debounce-action';
import Validator from '../../../../shared/validator';
import { editorValidate } from '../channel-editor-postal';
import {
  getEventRestrictions, updateEventRestrictions,
} from '../../../../services/wire/edit-event-restrictions-services';

export default class RestrictionsEventControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    restrictedToEventId: PropTypes.number.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      eventRequired: state => !state.isRestrictedToEvent || !!state.event,
    });

    this.state = {
      isRestrictedToEvent: this.props.restrictedToEventId !== -1,
      event: this.props.restrictedToEventId === -1
        ? null
        : { value: this.props.restrictedToEventId },
      events: [],
      validations: this.validator.getValidations(),
    };
    this.saveEventId = debounceAction({
      getCurrentValue: () => _.get(this.state.event, 'value', null),
      actionPromise: () => updateEventRestrictions(this.props.wireId, _.get(this.state.event, 'value', null)),
      onBeforeAction: () => this.loading.start(),
      onError: e => defaultOnErrorHandler(e, 'Error saving event id'),
      onAfterAction: () => this.loading.stop(),
    });
    this.toggleChange = this.toggleChange.bind(this);
    this.assignEvent = this.assignEvent.bind(this);

    editorValidate(this, 'restrictEvent');
  }

  componentDidMount() {
    this.loading.start();
    getEventRestrictions(this.props.wireId)
      .then(result => this.setState(state => {
        const id = result.data.restricted_to_event_id;
        state.isRestrictedToEvent = id !== null && id !== -1;
        state.events = result.data.events.map(e => ({ value: e.id, label: e.name }));
        state.event = _.find(state.events, { value: id }) || null;
        return state;
      }))
      .catch(e => defaultOnErrorHandler(e, 'Error getting wire restrictions'))
      .finally(() => this.loading.stop());
  }

  toggleChange(e) {
    const isRestrictedToEvent = e.target.value === 'true';

    this.setState(state => {
      state.isRestrictedToEvent = isRestrictedToEvent;
      if (!isRestrictedToEvent) {
        state.event = null;
      }
      state.validations = this.validator.validateForm(state);
      return state;
    }, () => isRestrictedToEvent || this.saveEventId());
  }

  assignEvent(event) {
    this.setState(state => {
      state.isRestrictedToEvent = true;
      state.event = event;
      state.validations = this.validator.validateForm(state);
      return state;
    }, () => this.saveEventId());
  }

  render() {
    const groupedOptions = [{
      label: 'Unrestricted',
      options: this.state.events,
    }];
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <form className="--user-facing">
            <section className={`form-group ${this.state.validations.formValid ? '' : 'has-error'}`}>
              <span className="sidebar-item-desc">Do you want to restrict this wire to an event?</span>
              <label htmlFor="event-yes" className="sidebar-item-radio-group">
                <input
                  id="event-yes"
                  type="radio"
                  value
                  checked={this.state.isRestrictedToEvent}
                  onChange={this.toggleChange}
                />
                Yes
              </label>
              <label htmlFor="event-no" className="sidebar-item-radio-group">
                <input
                  id="event-no"
                  type="radio"
                  value={false}
                  checked={!this.state.isRestrictedToEvent}
                  onChange={this.toggleChange}
                />
                No
              </label>
              <Loading variant="sip" ref={el => (this.loading = el)} />
              {this.state.isRestrictedToEvent && (
                <Select
                  className="select-container"
                  classNamePrefix="select"
                  value={this.state.event}
                  onChange={this.assignEvent}
                  options={groupedOptions}
                  placeholder={groupedOptions[0].label}
                  formatGroupLabel={d => (<div>{d.label}</div>)}
                />
              )}
              {!!this.state.validations.eventRequiredValid || <span className="help-block">Please select the event you want this wire to appear under.</span>}
            </section>
          </form>
        </aside>
      </ErrorBoundary>
    );
  }
}
